import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.USER_SET_USER_INFO]: (state, payload) => {
    state.userInfo = payload
  },
  [mutationsTypes.USER_SET_USER_LIST]: (state, payload) => {
    const base = payload.userList
    const userListTmp = base.map((ele) => {
      return {
        organizationId: ele.organizationId,
        lastName: ele.lastName,
        firstName: ele.firstName,
        phoneNumberCountryCode: ele.phoneNumberCountryCode,
        phoneNumber: ele.phoneNumber,
        email: ele.email,
        emailVerifiedAt: ele.emailVerifiedAt,
        createdAt: ele.createdAt,
        updatedAt: ele.updatedAt,
        organization: {
          organizationId: ele.organizationId,
          name: ele.name,
          currencyId: ele.currencyId,
          createdAt: ele.createdAt,
          updatedAt: ele.updatedAt
        }
      }
    })

    state.userList = payload.userList
  },
  [mutationsTypes.PRODUCT_EXPIRED_DATE_ALERT_UNREADS]: (state, payload) => {
    state.productExpiredDateAlertUnreads = payload
  },
  [mutationsTypes.USER_SET_UNREAD_NOTICE_COUNT]: (state, count) => {
    state.unreadNoticeCount = count
  },
  [mutationsTypes.USER_SET_TUTORIAL_STATUS]: (state, status) => {
    state.userInfo.tutorialStatus = status
  }
}

export default Mutations
